import React, { Component } from 'react';
import { Col, Row } from "react-bootstrap";
import { PieChart, Pie, ResponsiveContainer, Sector, Tooltip } from 'recharts';
import CustomToolTip from '../custom-tooltip/custom-tooltip';

const renderCustomLabel = (props) => {
  const RADIAN = Math.PI / 180;
  const {
    cx, cy, midAngle, outerRadius, value
  } = props;

  // Calculate the position for the label
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + outerRadius * cos;
  const sy = cy + outerRadius * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 20;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <path 
        d={`M${sx}, ${sy}L${mx}, ${my}L${ex}, ${ey}`}
        stroke="#018eff"
        fill="none"
      />
      <circle cx={ex} cy={my} r={2} fill="#018eff" stroke="none" />
      <text 
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor} 
        dominantBaseline="central"
        fill="#333">{value}
      </text>
    </g>
  );
};


export class LegendComp extends Component { 
  
  render() {
    return (
      <Row className="legend-cont">
          <Col xs={10} md={6} lg={6} className="legend-details" >
              {this.props.data && (this.props.data).map((key, i) => {
                  const prefix = key.classNamePrefix !== undefined ? key.classNamePrefix : key.name.toLowerCase().replaceAll(' ', '');
                  const fillColor = key.fill.toLowerCase().replaceAll("#","");
                  const classNames = `${prefix}-bg-color bg-color-${fillColor} cicle-tr-curr`;
                  return (
                      <div className="legend-value" key={key.name}>
                          <span className={`${classNames}`}></span>
                          {' ' + key.name}
                      </div>
                  )
              })}                  
          </Col>  
      </Row>
  )
  }
}

export class PieGraph extends Component {
  render() {
    const graphData = this.props.data;
    const {customHeight} = this.props;
    return (
      <div> 
        <ResponsiveContainer width="100%" height={customHeight ? customHeight : 400} marginTop='10'> 
          <PieChart width={400} height={400} > 
            <Pie data={graphData} dataKey="value" nameKey="name" cx="50%" cy="50%" startAngle={90} endAngle={-360} fill="#fff" outerRadius={100}  minAngle={10} legendType="triangle"
             label={renderCustomLabel} 
            />
            <Tooltip content={<CustomToolTip />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    );
  }
}